import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const HeadSetIcon: React.FC<CardGradientProps> = ({
  className,
  width = "1.46vw",
  height = "1.46vw",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1241_18450"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="21"
      >
        <rect width="21" height="21" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1241_18450)">
        <path
          d="M4.375 17.5C3.89375 17.5 3.48177 17.3286 3.13906 16.9859C2.79635 16.6432 2.625 16.2312 2.625 15.75V9.625C2.625 8.54583 2.83281 7.52865 3.24844 6.57344C3.66406 5.61823 4.22917 4.78333 4.94375 4.06875C5.65833 3.35417 6.49323 2.78906 7.44844 2.37344C8.40365 1.95781 9.42083 1.75 10.5 1.75C11.5792 1.75 12.5964 1.95781 13.5516 2.37344C14.5068 2.78906 15.3417 3.35417 16.0563 4.06875C16.7708 4.78333 17.3359 5.61823 17.7516 6.57344C18.1672 7.52865 18.375 8.54583 18.375 9.625V18.375C18.375 18.8563 18.2036 19.2682 17.8609 19.6109C17.5182 19.9536 17.1062 20.125 16.625 20.125H11.375C11.1271 20.125 10.9193 20.0411 10.7516 19.8734C10.5839 19.7057 10.5 19.4979 10.5 19.25C10.5 19.0021 10.5839 18.7943 10.7516 18.6266C10.9193 18.4589 11.1271 18.375 11.375 18.375H16.625V17.5H14.875C14.3938 17.5 13.9818 17.3286 13.6391 16.9859C13.2964 16.6432 13.125 16.2312 13.125 15.75V12.25C13.125 11.7688 13.2964 11.3568 13.6391 11.0141C13.9818 10.6714 14.3938 10.5 14.875 10.5H16.625V9.625C16.625 7.93333 16.0271 6.48958 14.8313 5.29375C13.6354 4.09792 12.1917 3.5 10.5 3.5C8.80833 3.5 7.36458 4.09792 6.16875 5.29375C4.97292 6.48958 4.375 7.93333 4.375 9.625V10.5H6.125C6.60625 10.5 7.01823 10.6714 7.36094 11.0141C7.70365 11.3568 7.875 11.7688 7.875 12.25V15.75C7.875 16.2312 7.70365 16.6432 7.36094 16.9859C7.01823 17.3286 6.60625 17.5 6.125 17.5H4.375Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export default HeadSetIcon;
